export default __webpack_public_path__ + "static/media/malala.4658494a.jpg";